import { configureStore } from "@reduxjs/toolkit";
import localforage from "localforage";
import { combineReducers } from "redux";
import { createMigrate, persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import { migrations } from "./middlewares/migrations";

import ensaioAnaliseReducer from "./reducers/ensaioAnalise";
import estabelecimentoReducer from "./reducers/estabelecimento";
import formularioReducer from "./reducers/formulario";
import formularioControleRespostaReducer from "./reducers/formularioControleResposta";
import laboratorioReducer from "./reducers/laboratorio";
import marcaProdutoReducer from "./reducers/marcaProduto";
import menusReducer from "./reducers/menu";
import motivoNotificacaoReducer from "./reducers/motivoNotificacao";
import produtoAuorizadoReducer from "./reducers/produtoAutorizado";
import programacaoColetaAnaliseReducer from "./reducers/programacaoColetaAnalise";
import relatorioAMReducer from "./reducers/relatorioAM";
import requisicaoAnaliseReducer from "./reducers/requisicaoAnaliseLaboratorial";
import servidorReducer from "./reducers/servidor";
import termoNotificacaoReducer from "./reducers/termoNotificacao";
import usuarioLogadoReducer from "./reducers/usuarioLogado";

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

const rootReducer = combineReducers({
  usuarioLogado: usuarioLogadoReducer,
  menus: menusReducer,
  requisicaoAnaliseLaboratorial: requisicaoAnaliseReducer,
  estabelecimento: estabelecimentoReducer,
  ensaioAnalise: ensaioAnaliseReducer,
  servidor: servidorReducer,
  produtoAutorizado: produtoAuorizadoReducer,
  marcaProduto: marcaProdutoReducer,
  programacaoColetaAnalise: programacaoColetaAnaliseReducer,
  motivoNotificacao: motivoNotificacaoReducer,
  termoNotificacao: termoNotificacaoReducer,
  formulario: formularioReducer,
  relatorioAM: relatorioAMReducer,
  formularioControleResposta: formularioControleRespostaReducer,
  laboratorio: laboratorioReducer,
});

localforage.config({
  name: "storage",
  size: 10080736,
  driver: localforage.INDEXEDDB,
  storeName: "INSPECAO_MOBILE",
  version: 1.0,
  description: "Armazenamento local do app Inspeção Mobile",
});

const persistConfig = {
  key: "root",
  storage: localforage,
  version: 3,
  blacklist: [],
  transforms: [],
  migrate: createMigrate(migrations, { debug: false }),
  stateReconciler: autoMergeLevel2,
};

const persistedReducer = persistReducer<ReturnType<typeof rootReducer>>(
  persistConfig,
  rootReducer
);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddlewares) => [
    ...getDefaultMiddlewares({
      serializableCheck: false,
      immutableCheck: { warnAfter: 128 },
    }),
  ],
});

export const persistor = persistStore(store);
